<template>
  <ul class="error-messages">
    <li class="error" v-for="(message, index) in errors" :key="index" v-html="message"></li>

    <li class="error" v-if="isTwitter" v-html="twitterError"></li>

    <li v-if="isTwitter">
      <a href @click="logoutAndRedirect()">Logout and create Nav 3 account</a>
    </li>
  </ul>
</template>

<script>
import { publicationAccessParameters } from 'config';

export default {
  name: 'ErrorMessages',
  props: ['errors'],
  methods: {
    logoutAndRedirect() {
      this.$store.dispatch('auth/logout');
      this.$router.push({ name: 'Artworks', query: {} });
    },
  },
  computed: {
    isTwitter() {
      return this.errors && this.errors.twitter_account;
    },

    twitterError() {
      return publicationAccessParameters.private_no_twitter_message.fr;
    },
  },
};
</script>
